// URL del backend (FastAPI).
// Orden de prioridad:
// 1) REACT_APP_BACKEND_URL si está definida en el build (dev en Coolify, local o las vistas de Vercel).
// 2) En Vercel (*.vercel.app) sin esa variable: ningún backend. Las vistas de Vercel llevan código de
//    develop y nunca deben tocar la base de producción; para usarlas con datos, define
//    REACT_APP_BACKEND_URL en Vercel con la URL del backend de dev.
// 3) Por defecto (dominio real): producción, https://api.freedomhomes.club
export const PROD_API_URL = 'https://api.freedomhomes.club';
const ENV_URL = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/+$/, '');

const isVercel =
  typeof window !== 'undefined' && window.location.hostname.endsWith('.vercel.app');

export const BACKEND_URL = ENV_URL || (isVercel ? '' : PROD_API_URL);

export const API_URL = `${BACKEND_URL}/api`;
